<template>
  <!-- 产品页面中的blog -->
  <section class="blog-warp">
    <h2 class="ta-c">News</h2>
    <ul class="d-f jc-c blog-mod">
      <li v-for="(item, index) in blogData" :key="item.id" @click.stop="gotoRoute(item.url, item.id)">
        <div class="img-box">
          <!-- <a
            href="https://betanew.fjdynamics.com//blog/76-FJD-3D-Excavator-Guidance-System-Effectively-Reduces-Fuel-Consumption-and-Increases-Construction-Efficiency.html"
            one-link-mark="yes"
            ><img
              class="lazy-image"
              v-lazy="item.coverImg"
              data-original="https://fj-fjdynamics-storage-01-1304943718.cos.ap-shanghai.myqcloud.com/1111.png"
              width="100%"
              height="100%"
              :alt="item.title"
              style=""
          /></a> -->
          <a class="d-b h-100p" target="_blank">
            <img class="blog-img" v-lazy="item.coverImg" width="100%" height="100%" :alt="item.title" />
          </a>
        </div>
        <div class="text-box">
          <h3 class="ellipsis wlc-2">
            {{ item.title }}
          </h3>
          <hr />
          <div class="desc ellipsis wlc-3">{{ item.introduction }}</div>
          <div class="date-share d-f ai-c jc-sb p-r">
            <strong class="d-f ai-c c-999 fs-16 fw-400"
              ><i class="date-icon d-ib bgs-cover"></i>{{ item.createTime.slice(0, 11) }}
            </strong>
            <div class="share-box d-f ai-c">
              <!-- <div class="share-container d-n ai-c"></div> -->
              <div
                class="share-container ai-c"
                v-show="showShareWrap && activeIndex === index"
                @mouseenter="mouseenterShare(index)"
                @mouseleave="mouseleaveShare"
              >
                <a
                  v-for="(shareItem, idx) in shareIcon"
                  :key="idx"
                  href="javascript:;"
                  :data-site="shareItem.site"
                  :class="shareItem.className"
                  @click="processShare(shareItem.site)"
                  class="d-ib bgs-cover"
                ></a>
              </div>
              <div
                class="share-ico d-ib c-p bgs-cover"
                @mouseenter="mouseenterShare(index)"
                @mouseleave="mouseleaveShare"
              ></div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="d-f jc-c more-btn" v-if="hasMore">
      <nuxt-link class="d-ib ta-c c-333" :to="`/blog`" title="more blog">Read More</nuxt-link>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      blogData: {
        type: Array,
        default: () => []
      },
      hasMore: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showShareWrap: false,
        timer: null,
        activeIndex: -1,
        shareIcon: [
          {
            site: 'facebook',
            className: 'facebook-black'
          },
          {
            site: 'linkedin',
            className: 'linkedin-black'
          },
          {
            site: 'twitter',
            className: 'twitter-black'
          }
        ]
      }
    },
    created() {},
    mounted() {},
    methods: {
      mouseenterShare(index) {
        this.activeIndex = index
        console.log('[ index,this.activeIndex ] >', index, this.activeIndex)
        if (this.timer) clearTimeout(this.timer)

        this.showShareWrap = true
        // console.log('[ this.getMetaContent() ] >', this.getMetaContent('keywords'))
      },
      mouseleaveShare() {
        this.timer = setTimeout(() => {
          this.showShareWrap = false
        }, 100)
      },
      processShare(key) {
        const options = {
          url: document.location.href || '',
          title: document.title || '',
          desc: this.getMetaContent('description') || '',
          source: 'fjdynamics',
          origin: location.origin || ''
        }

        const siteMap = {
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${options.url}&t=${options.title}`,
          linkedin: `http://www.linkedin.com/shareArticle?mini=true&ro=true&title= ${options.title}&url= ${options.url}&summary= ${options.desc}&source= ${options.source}&armin=armin`,
          twitter: `https://twitter.com/intent/tweet?text=${options.title}&url=${options.url}&via=${options.origin}`
        }
        this.openWindow(siteMap[key])
      },
      openWindow(url) {
        const ww = document.documentElement.clientWidth
        const wh = document.documentElement.clientHeight
        const iWidth = ww * 0.5
        const iHeight = wh * 0.7
        const iLeft = Number(ww - iWidth) / 2
        const iTop = Number(wh - iHeight) / 2

        window.open(
          url,
          '',
          'width=' +
            iWidth +
            ',height=' +
            iHeight +
            ',top=' +
            iTop +
            ',left=' +
            iLeft +
            ',toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no'
        )
      },
      getMetaContent(key) {
        const metas = document.getElementsByTagName('meta')
        return metas[key]['content'] || ''
      }
    }
  }
</script>

<style scoped lang="scss">
  /* area-11 */
  .blog-warp {
    padding-bottom: 1.6rem;
  }
  .blog-warp h2 {
    margin-bottom: 0.32rem;
    font-size: 0.48rem;
    font-weight: 700;
    color: #333;
  }
  .blog-mod {
    // padding-top: 0.6rem;
  }
  .blog-mod li {
    width: 4.4rem;
    margin-left: 0.16rem;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
  }
  .blog-mod li:nth-of-type(1) {
    margin-left: 0;
  }
  .blog-mod li .img-box {
    height: 2.48rem;
    position: relative;
    overflow: hidden;
  }
  .blog-mod li .img-box a {
    display: block;
    height: 100%;
  }
  .blog-mod li .img-box img {
    transition: transform 0.2s linear;
  }
  .blog-mod li .img-box:hover img {
    transform: scale(1.1);
  }
  .blog-mod li hr {
    border: none;
    border-top: 1px solid #bfbfbf;
    width: 0.6rem;
    margin: 0.24rem 0;
  }
  .blog-mod li .text-box {
    height: 2.98rem;
    padding: 0 0.24rem;
    border-top: none;
    font-size: 0.16rem;
    overflow: hidden;
    position: relative;
  }
  .blog-mod li .desc {
    color: #999;
  }
  .blog-mod li h3 {
    padding-top: 0.24rem;
    font-size: 0.2rem;
    color: #333;
    font-weight: 500;
    min-height: 0.84rem;
  }

  .area-12 {
    // margin-bottom: 1.6rem;
  }
  .area-12 h2 {
    margin-bottom: 0.32rem;
  }
  .area-12 .blog-mod li h3 {
    height: 0.6rem;
  }
  .area-12 .blog-mod li .text-box {
    height: 2.98rem;
    position: relative;
  }
  .area-12 .blog-mod li .desc {
    margin-bottom: 0.32rem;
  }

  .share-container {
    height: 0.25rem;
    line-height: 0.25rem;
  }
  .date-icon,
  .share-ico,
  .share-container a {
    width: 0.25rem;
    height: 0.25rem;
  }
  .date-share {
    position: absolute;
    bottom: 0.32rem;
    left: 0.24rem;
    right: 0.24rem;
  }
  .date-icon {
    margin-top: -0.03rem;
    margin-right: 0.12rem;
  }
  .share-ico {
    transition: transform 0.3s;
    margin-left: 0.1rem;
  }
  .share-ico:hover {
    transform: scale(1.2);
  }
  .share-container a {
    transition: transform 0.3s;
    font-size: 0;
    margin: 0 0.05rem;
  }
  .share-container a:hover {
    transform: scale(1.2);
  }
  .more-btn {
    margin-top: 0.64rem;
  }
  .more-btn a {
    padding: 0 0.3rem;
    line-height: 0.4rem;
    font-size: 0.16rem;
    border: 1px solid #333;
    box-sizing: border-box;
  }
</style>
